import React from 'react';

const Loader = () => {
  return (
    <div>
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
